<template>
  <div class="sku-header">
    <div class="container top-navigation">
      <nav class="navbar navbar-expand-lg navbar-light row">
        <a class="navbar-brand" href="#/home">
          <img src="@/assets/images/sangkien/fptlogo.png" alt />
        </a>
        <button
          class="navbar-toggler collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div
          class="collapse navbar-collapse collapse-custom"
          id="navbarSupportedContent"
        >
          <ul class="navbar-nav mr-auto navbar-left">
            <li class="nav-item dropdown" v-if="myIdea && myIdea.show">
              <Dropdown
                id="menuItemsUser"
                :menuItems="myIdea.data"
                :dropdownName="myIdea.name"
              ></Dropdown>
            </li>
            <li class="nav-item dropdown" v-if="iKhiens && iKhiens.show">
              <Dropdown
                id="menuItemsUser"
                :menuItems="iKhiens.data"
                :dropdownName="iKhiens.name"
              ></Dropdown>
            </li>

            <li
              class="nav-item"
              v-for="(menu, index) in leftMenu"
              :key="index"
              v-show="menu.show"
            >
              <a class="nav-link" :href="menu.href">{{ menu.name }}</a>
            </li>
            <li
              class="nav-item dropdown"
              v-if="menuItemsUser && menuItemsUser.show"
            >
              <Dropdown
                id="menuItemsUser"
                :menuItems="menuItemsUser.data"
                dropdownName="Quản trị"
              ></Dropdown>
            </li>
          </ul>
          <ul class="navbar-nav ml-auto">
            <li class="nav-item pr-4">
              <a class="sku-btn-submission" href="#/new-submission"
                >Đăng ký sáng kiến</a
              >
            </li>

            <li
              class="nav-item"
              v-for="(menu, index) in rightMenu"
              :key="index"
              v-show="menu.show"
            >
              <a class="nav-link" :href="menu.href">{{ menu.name }}</a>
            </li>
            <li class="nav-item dropdown">
              <Dropdown
                :menuItems="menuItemsLogout"
                :dropdownName="username.toUpperCase()"
              ></Dropdown>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>
<script>
import Dropdown from './Dropdown.vue'
import * as CONFIG from '../../config/index'
import axios from 'axios'
import masterDataCommon from '../../common/masterData'
import helper, { checkPermission } from '../../common/helper'

const forumUrl = 'https://insight.fsoft.com.vn/forum'

export default {
  name: 'Header',
  components: {
    Dropdown
  },
  data() {
    return {
      username: this.$cookies.get('username') || 'Anonymous',
      masterDataId: '',
      menuItemsUser: {
        show:
          checkPermission(CONFIG.SCREEN_CODE.LOG_ACTIVITY, 'VIEW') ||
          checkPermission(CONFIG.SCREEN_CODE.BANNER_MANAGER, 'VIEW') ||
          checkPermission(CONFIG.SCREEN_CODE.MASTER_DATA, 'VIEW') ||
          checkPermission(CONFIG.SCREEN_CODE.ROLE_MANAGER, 'VIEW') ||
          checkPermission(CONFIG.SCREEN_CODE.CTTV_MANAGER, 'VIEW'),
        data: [
          {
            name: 'Quản lý lịch sử',
            href: `${CONFIG.CLIENT_URL}/#/activity_manager`,
            show: checkPermission(CONFIG.SCREEN_CODE.LOG_ACTIVITY, 'VIEW')
          },
          {
            name: 'Quản lý banner',
            href: `${CONFIG.CLIENT_URL}/#/manage-banner`,
            show:
              checkPermission(CONFIG.SCREEN_CODE.BANNER_MANAGER, 'VIEW') &&
              this.$cookies.get('globalRoles') === 'true'
          },
          {
            name: 'Quản lý dữ liệu',
            href: `${CONFIG.CLIENT_URL}/#/master-data`,
            show: checkPermission(CONFIG.SCREEN_CODE.MASTER_DATA, 'VIEW')
          },
          {
            name: 'Quản lý phân quyền',
            href: `${CONFIG.CLIENT_URL}/#/roles-manager`,
            show: checkPermission(CONFIG.SCREEN_CODE.ROLE_MANAGER, 'VIEW')
          },
          {
            name: 'Quản lý CTTV',
            href: `${CONFIG.CLIENT_URL}/#/cttv-manager`,
            show: checkPermission(CONFIG.SCREEN_CODE.CTTV_MANAGER, 'VIEW')
          },
          {
            name: 'Quản lý tài khoản',
            href: `${CONFIG.CLIENT_URL}/#/account-manager`,
            show: checkPermission(CONFIG.SCREEN_CODE.ACCOUNT_MANAGER, 'VIEW')
          }
        ]
      },
      myIdea: {
        name: 'Sáng kiến',
        show: true,
        data: [
          {
            name: 'Sáng kiến của tôi',
            href: `${CONFIG.CLIENT_URL}/#/my-submission`,
            show: true
          },
          {
            name: 'Sáng kiến được công nhận',
            href: `${CONFIG.CLIENT_URL}/#/browse-ip/sangkien`,
            show: true
          }
        ]
      },
      iKhiens: {
        name: 'iKhiến',
        show: true,
        data: [
          {
            name: 'Danh sách chờ thi iKhiến',
            href: `${CONFIG.CLIENT_URL}/#/idea-contest`,
            show: checkPermission(CONFIG.SCREEN_CODE.IDEA_CONTEST, 'VIEW')
          },
          {
            name: 'Danh sách chấm điểm iKhiến',
            href: `${CONFIG.CLIENT_URL}/#/idea-examination`,
            show:
              checkPermission(CONFIG.SCREEN_CODE.IDEA_EXAMINATION, 'VIEW') &&
              this.$cookies.get('globalRoles') === 'true'
          },
          {
            name: 'Danh sách kết quả iKhiến',
            href: `${CONFIG.CLIENT_URL}/#/idea-recognition`,
            show: true
          },
          {
            name: 'Quản lý folder chung khảo',
            href: `${CONFIG.CLIENT_URL}/#/final-folder`,
            show:
              checkPermission(CONFIG.SCREEN_CODE.FINAL_FOLDER, 'VIEW') &&
              this.$cookies.get('globalRoles') === 'true'
          }
        ]
      },
      leftMenu: {
        report: {
          name: 'Báo cáo',
          href: `${CONFIG.CLIENT_URL}/#/headlines`,
          show: checkPermission(CONFIG.SCREEN_CODE.REPORT, 'VIEW')
        }
      },
      rightMenu: {
        reviewSubmission: {
          name: 'Duyệt sáng kiến',
          href: `${CONFIG.CLIENT_URL}/#/review-submission`,
          show: helper.checkReviewSubmit()
        }
      },
      menuItemsLogout: [
        {
          name: 'Đăng xuất',
          href: `${CONFIG.CLIENT_URL}/#/process-logout`
        }
      ]
    }
  },
  methods: {
    logout: function() {
      window.localStorage.setItem('accessToken', null)
      this.$cookies.remove('username')
      this.$router.push({ name: 'LoginPage' })
    }
  }
}
</script>

<style>
@media (min-width: 992px) {
  .sku-header .navbar-expand-lg .navbar-nav .nav-link,
  .sku-header .navbar-expand-lg .navbar-nav .dropdown-toggle {
    padding-right: 15px;
    padding-left: 0;
  }
}

.sku-space .sku-dropdown {
  position: relative;
}

.sku-space .dropdown-menu {
  padding-top: 8px;
  padding-bottom: 8px;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  left: auto;
  top: 30px;
}

.sku-space .sku-dropdown .dropdown-menu > li a {
  font-size: 12px;
  color: #676a6c;
  white-space: nowrap;
  padding: 7px 30px;
  display: block;
  cursor: pointer;
}

.sku-space .sku-dropdown .dropdown-menu > li a:hover {
  text-decoration: none;
  background: #ecf0f1 !important;
}

.sku-header .navbar {
  padding: 0;
}

.sku-header
  .navbar-light
  .navbar-nav
  .sku-space
  .sku-dropdown
  .dropdown-toggle {
  border-radius: 14px;
  border: solid 1px #3299ba;
  text-align: center;
  padding: 5px 20px;
  font-size: 13px;
  color: #898e97;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: normal;
}
.sku-header
  .navbar-light
  .navbar-nav
  .sku-space
  .sku-dropdown
  .dropdown-toggle
  span {
  font-size: 13px;
}
.sku-header
  .navbar-light
  .navbar-nav
  .sku-space
  .sku-dropdown
  .dropdown-toggle
  .selected-value {
  color: #e07254;
  font-weight: bold;
}

.navbar-right .sku-dropdown .dropdown-menu {
  right: 0;
  left: auto;
}
.sku-btn-submission {
  box-shadow: 0 10px 15px 0 rgba(224, 115, 83, 0.18);
  background-color: rgb(237, 134, 82);
  padding: 5px 20px;
  color: rgb(255, 255, 255);
  border-radius: 20px;
  font-size: 13px;
  border: solid 1px rgb(237, 134, 82);
}

.sku-btn-submission:hover {
  background-color: rgba(237, 134, 82, 0.67);
  color: #fff;
  text-decoration: none;
}

.sku-btn-help {
  border-right: 1px solid #000;
  border-left: 1px solid #000;
  padding: 1px 7px !important;
}

.sku-btn-help i {
  margin: 0 5px;
}

.sku-header {
  background-color: #fff;
}

.sku-header .navbar {
  height: 75px;
}

.sku-header .navbar-brand img {
  width: 140px;
  height: 38px;
  object-fit: contain;
}

.sku-header .dropdown-toggle::after {
  display: none;
}

.sku-header .navbar-light .navbar-nav .nav-link,
.sku-header .navbar-light .navbar-nav .dropdown-toggle {
  color: #1e242f;
  font-weight: 600;
  font-size: 14px;
}

.sku-header .nav-item {
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sku_tags {
  width: 193px;
  height: 48px;
  border-radius: 26px;
  border: solid 1px #e3e9f0;
  background-color: #ffffff;
}

.popular_tag_count {
  width: 18px;
  height: 22px;
  font-family: OpenSans;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: 0.13px;
  text-align: left;
  color: #e07254;
}

.popular_tag_name {
  width: 128px;
  height: 22px;
  font-family: OpenSans;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: 0.13px;
  text-align: left;
  color: #1e242f;
}

li.nav-item > a:hover,
ul > li .dropdown-toggle:hover {
  color: #3299ba !important;
}

.collapse-custom {
  /* z-index: 1000000;
    background:#fbfbfb; */
  border-radius: 3px;
  padding: 10px 0px;
}

@media (max-width: 576px), (max-width: 767.98px), (max-width: 992px) {
  #navbarSupportedContent {
    z-index: 9;
    background-color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue